import React from "react";
import styled from "styled-components";
interface Props {
  uid: string;
  imageUrl: string;
  onClick: (bookingId: string) => void;
  bookingId: string;
  isRead: boolean;
}
const Container = styled.div`
  position: relative;
  margin: 0.5rem 0rem;
  cursor: pointer;
`;
const AvatarProfile = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 9999px;
`;
const NotiPoint = styled.span`
  width: 1rem;
  height: 1rem;
  border-radius: 9999px;
  background-color: red;
  position: absolute;
  bottom: 0;
  right: 0;
`;
const ChatList = (props: Props) => {
  return (
    <Container onClick={() => props.onClick(props.bookingId)}>
      <AvatarProfile alt={`avatar: ${props.uid}`} src={props.imageUrl} />
      {!props.isRead && <NotiPoint />}
    </Container>
  );
};

export default ChatList;
